import type { BooleanFlag } from './baseTypes';

export type PanoFovType = 'VFOV' | 'HFOV' | 'DFOV' | 'MFOV';

export enum MatrixFovType {
  fullscreen = 0, // 全屏
  custom = 1, // 自定义
  fill = 2, // 铺满全屏 ？？
}

export interface ViewData {
  fovMax: number;
  fovMin: number;
  fov: number;
  /** 视角类型 */
  fovType: PanoFovType;
  /** 加载场景时保持初始视角 */
  loadSceneKeepView: BooleanFlag;
  /** 自动巡游时保持初始视角 */
  autoRotateKeepView: BooleanFlag;
  vLookAt: number;
  vLookAtMax: number;
  vLookAtMin: number;
  hLookAt: number;
  hLookAtMax: number;
  hLookAtMin: number;
  /** 矩阵视角类型 */
  flatFovType: MatrixFovType;
  /** 视角最大缩放倍数 */
  maxPixelZoom: number;
  /** 高清矩阵视角缩放开关, 默认`0`, v5.8.12 */
  disableZoom?: BooleanFlag;
}
